import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import styleFilter from './styleFilter';
import { Button } from '@material-ui/core';

export function FilterStatusHeader({ fetchFunc, status, setStatus }) {
  const classes = styleFilter();
  const [openModalFilter, setModalFilter] = useState(false);

  return (
    <div className={classes.actions}>
      <button
        className={classes.button}
        variant="contained"
        onClick={() => setModalFilter(!openModalFilter)}
        style={{ padding: '4px 16px' }}
      >
        <span>Filtros</span>
      </button>
      {openModalFilter && (
        <div className={classes.filtersBox}>
          <div className={classes.headFilter}>
            <span className={classes.labelFilter}>Status:</span>
            <button
              className={classes.buttonClose}
              onClick={() => setModalFilter(!openModalFilter)}
            >
              <CloseIcon style={{ fontSize: 25, color: '#fff' }} />
            </button>
          </div>
          <select
            onChange={(event) => setStatus(event.target.value)}
            value={status}
            className={classes.selectStatus}
          >
            <option value="">Todos</option>
            <option value="ativo">Ativo</option>
            <option value="inativo">Inativo</option>
            {/* <option value="pendente">Pendente</option> */}
            {/* <option value="pendentedeativar">Pendente De Ativar</option> */}
            {/* <option value="pendentedeinativar">Pendente De Inativar</option> */}
          </select>
          <button className={classes.buttonFilter} onClick={() => fetchFunc()}>
            Aplicar Filtro
          </button>
        </div>
      )}
    </div>
  );
}
